<script setup lang="ts">
import type { RiskConfig, RiskShort } from '@/models/api-generated'
import { scoreToLevel } from './shared'
import { RT_Exclude } from '@/models/enums-generated'

const props = defineProps<{
	risks: RiskShort[]
	config?: RiskConfig
}>()

const riskColor = (risk: RiskShort, config?: RiskConfig) => {
	return risk.treatment === RT_Exclude ? 'gray' : scoreToLevel(risk.residual, config)?.color || 'gray'
}
</script>

<template>
	<div class="d-flex flex-wrap gap-2">
		<div v-for="risk in props.risks" :key="risk.metaId" class="d-flex align-items-center gap-1">
			<span class="badge bg-primary me-2 fixed-badge">
				{{ risk.assetId ? 'A' : 'D' }}
			</span>
			<span>{{ risk.name }}</span>
			<i class="bi bi-circle-fill me-2 ms-2" :style="{ color: riskColor(risk, props.config) }"></i>
		</div>
	</div>
</template>
